import { styled } from '@mui/system';

const HorizontalSeparator = styled('hr')(() => ({
    display: 'block',
    position: 'relative',
    left: 'calc((100vw - 1120px) / 2 * -1)',
    margin: 0,
    height: '1px',
    width: '100vw',
    border: 'none',
    borderBottom: '1px solid var(--gov-color-blue-light)',
}));

export default HorizontalSeparator;